import request from '@/utils/request'

const _Prefix = "/customerResourceSet"

// 查询客源信息列表
export function touristResourceList(query) {
    return request({
        url: _Prefix + '/list',
        method: 'get',
        params: query
    })
}


// 查询客源信息详细
export function getTouristResource(id) {
    return request({
        url: _Prefix + '/' + id,
        method: 'get'
    })
}

// 新增客源信息
export function addTouristResource(data) {
    return request({
        url: _Prefix,
        method: 'post',
        data: data
    })
}

// 修改客源信息
export function updateTouristResource(data) {
    return request({
        url: _Prefix,
        method: 'put',
        data: data
    })
}

// 删除客源信息
export function delTouristResource(id) {
    return request({
        url: _Prefix + '/' + id,
        method: 'delete'
    })
}